import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import logo from '../../assets/aba/logo-aba.png'
import fotoFabrica2 from '../../assets/historia2.png'
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next'


const block1 = {
    backgroundColor: 'violet',
    fontSize: '20px',
  };
const block2 = {
    backgroundColor: 'yellow',
    fontSize: '20px',
};

const container = {
  marginTop: '30px',
  textAlign: 'justify'
}


function OurHistory() {

    const { i18n, t } = useTranslation();

    return (
      <Container style={container}>
        <Row>
          <Col><h2>{t('historyTitle')}</h2></Col>
        </Row>
        <Row>
          <Col xs={12} md={6}>
          <img
                src={fotoFabrica2}
                width="100%"
                height="100%"
                className="d-inline-block align-top"
                alt="Aba logo"
              />
          </Col>
          <Col xs={12} md={6}>
            <h3>{t('historySubtitle')}</h3>
            <p>{t('histoyText1')}</p>
              <Link to='/history'><Button variant="primary">{t('btnHistory')}</Button></Link>
          </Col>

        </Row>
      </Container>
    );
  }
  
  export default OurHistory;